import { css } from '@emotion/react'
import {
  Color,
  FontWeight,
  Shadow,
  ShadowElevation,
  Spacing,
  Typography,
} from '@opallabs/gem'

const CARD_RADIUS = 8

const base = css({
  borderRadius: CARD_RADIUS,
  marginBlockEnd: Spacing.M,
  ...Shadow[ShadowElevation.E1],
})

const textarea = css({
  backgroundColor: `${Color.light.Surface.N000} !important`,
  color: `${Color.light.Text.Default} !important`,
  borderRadius: `${CARD_RADIUS}px ${CARD_RADIUS}px 0 0 !important`,
  fontWeight: FontWeight.Bold,
  blockSize: Spacing.XS * 11,
  lineHeight: '20px',
  padding: Spacing.XS,
  '&::placeholder': {
    fontWeight: FontWeight.Bold,
    color: Color.light.Text.Gray,
  },
  '&:focus': {
    border: `solid 1px ${Color.light.Surface.A000}`,
  },
})

const cardBody = css({
  borderRadius: CARD_RADIUS,
  backgroundColor: Color.light.Surface.N000,
  marginBlockEnd: Spacing.M,
  ...Shadow[ShadowElevation.E1],
  '.kuiper-loader-container': {
    borderRadius: `${CARD_RADIUS}px ${CARD_RADIUS}px 0 0`,
  },
})

const cardFooter = css({
  borderBottomLeftRadius: CARD_RADIUS,
  borderBottomRightRadius: CARD_RADIUS,
  borderTop: `solid 1px ${Color.light.Surface.N300}`,
  padding: Spacing.S,
  position: 'relative',
  backgroundColor: '#f7f8fa',
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  gap: Spacing.XS,
})

const leftActions = css({
  alignItems: 'center',
  display: 'flex',
  gap: Spacing.XS,
})

const createButton = css({
  ...Typography.T300,
  height: Spacing.L,
  paddingInline: Spacing.M,
})

export const contentCreatorStyles = {
  base,
  cardBody,
  cardFooter,
  createButton,
  leftActions,
  textarea,
}

const pickerHeader = css({
  ...Typography.T300,
  color: Color.light.Text.Gray,
  paddingBlock: 6,
  paddingInline: Spacing.S,
})

const pickerEmptyState = css({
  ...Typography.T300,
  color: Color.light.Text.Gray,
  paddingBlock: Spacing.S,
  paddingInline: Spacing.S,
})

const pickerItem = css({
  alignItems: 'center',
  display: 'flex',
  gap: Spacing.XS,
})

const pickerItemLabel = css({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
})

const pickerSeparator = css({
  backgroundColor: Color.light.Surface.N200,
  blockSize: 1,
  marginBlock: 4,
})

const attachMomentButton = (isOpen: boolean, hasSelection: boolean) =>
  css({
    ...Typography.T300,
    borderRadius: 6,
    height: Spacing.L,
    justifyContent: 'center',
    paddingInline: Spacing.S,
    backgroundColor: hasSelection
      ? Color.light.Surface.A100
      : Color.light.Surface.N000,
    borderColor:
      isOpen || hasSelection
        ? Color.light.Surface.A200
        : Color.light.Surface.N300,
    '&:hover': {
      borderColor: Color.light.Surface.A200,
    },
  })

export const attachMomentPickerStyles = {
  button: attachMomentButton,
  emptyState: pickerEmptyState,
  header: pickerHeader,
  item: pickerItem,
  itemLabel: pickerItemLabel,
  separator: pickerSeparator,
}

const channelButton = (isOpen: boolean, disabled: boolean) =>
  css({
    ...Typography.T300,
    borderRadius: 6,
    height: Spacing.L,
    justifyContent: 'center',
    paddingInline: Spacing.S,
    backgroundColor: Color.light.Surface.N000,
    borderColor: isOpen ? Color.light.Surface.A200 : Color.light.Surface.N300,
    '&:hover': {
      borderColor: disabled
        ? Color.light.Surface.N300
        : Color.light.Surface.A200,
    },
    '&:disabled': {
      borderColor: Color.light.Surface.N300,
    },
  })

const channelItem = css({
  alignItems: 'center',
  display: 'flex',
  gap: 8,
})

export const channelPickerStyles = {
  button: channelButton,
  item: channelItem,
}
